import React, { useState, useEffect, useRef } from "react";
import FilterData from "./filterData";
import * as Icon from "react-bootstrap-icons";
import ShowData from "./showData";
import { Formik, Form, ErrorMessage, getIn } from "formik";
import { monthTH } from "../../../Data/month-th.json";
import DateTH from "../../../Helper/date-th";
import { CustomerTypeService } from "../../../Service/service.Barcode";
import * as Yup from "yup";
import { connect } from "react-redux";
import { InsertData2 } from "../../../Service/service.goods";
import { swalSuccess, swalError } from "../../../Components/sweetAlert";
import { GetData } from "../../../Service/service.goods";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import { UpdateDimensions } from "../../../Service/service.goods";
import {calculatedPrice as calculatedPriceAPI, CheckDimensions} from "../../../Service/service.Parcels";
import { Tab, Tabs } from 'react-bootstrap';
import {ShowEmpService} from "../../../Service/service.Employee";
import { Typeahead } from 'react-bootstrap-typeahead';

function Accounting(props) {
  const { user } = props;
  // const inputs = useRef([]);
  const inputsRef = useRef([]);
  
  const dimensionSchema = Yup.object().shape({
    weight: Yup.number()
      .typeError('Weight must be a number')
      .positive('Weight must be greater than 0')
      .required('Weight is required'),
    box_length: Yup.number()
      .typeError('Length must be a number')
      .positive('Length must be greater than 0')
      .required('Length is required'),
    box_width: Yup.number()
      .typeError('Width must be a number')
      .positive('Width must be greater than 0')
      .required('Width is required'),
    box_height: Yup.number()
      .typeError('Height must be a number')
      .positive('Height must be greater than 0')
      .required('Height is required')
  });
  const schema = Yup.object().shape({
    items: Yup.array().of(dimensionSchema).nullable(),
    driver: Yup.string()
    .required("กรุณาระบุเลขบาร์โค้ด"),
    awbCode: Yup.string()
        .required("กรุณาระบุเลขบาร์โค้ด")
        // .min(16, 'ความยาวของบาร์โค้ดควรเป็น 16')
        // .max(16, 'ความยาวของบาร์โค้ดควรเป็น 16'),
  });
  const [shipmentStatus, setShipmentStatus] = useState("20");
  const [perPage, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [page, setPage] = useState({
    current_page: 0,
    last_page: 1,
    total: 0,
  });
  const [pageNo, setCurrentPage] = useState(1);
  const [loading, Loading] = useState(0);
  const [errorMassNoData, setErrorMassNoData] = useState(0);

  var year = new Date().getFullYear();
  var years = Array.from(new Array(3), (e, index) => year - index);
  var month = new Date().getMonth() + 1;
  var date = new Date().getDate();

  const [listDimensions,SetListDimensions]= useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [errorMassNoData2, SetErrorMassNoData2] = useState(0);

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [priceLoading, setPriceLoading] = useState(false);
  const [listDriver, setListDriver]= useState([]);
  const [driver,setDriver]=useState("");
  const [customer_type, Customer_type] = useState("");
  const [cust_code, Cust_code] = useState([]);
  const [cust, Cust] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [shipStatus, SetStatus] = useState("10");
  const [startdate1, SetStart1] = useState("");
  const [startdate2, SetStart2] = useState("");
  const [startdate3, SetStart3] = useState("");
  const [enddate1, SetEnd1] = useState("");
  const [enddate2, SetEnd2] = useState("");
  const [enddate3, SetEnd3] = useState("");
  const [cod, COD] = useState("");
  const [awbCodeSta, setCodStatus] = useState("");
  const [cod_cost, Cod_cost] = useState("");
  const [search_ID, Search_ID] = useState("");
  const [search_name, Search_name] = useState("");
  const [sender_name, Sender_name] = useState("");
  const [parcel_code, Parcel_Code] = useState("");
  const [bank_id, Bank_id] = useState("");
  const [bookbank_code, Bookbank_code] = useState("");
  const [bookbank_name, Bookbank_name] = useState("");
  const [setError, SetError] = useState("form-control");
  const [setErrorMass, SetErrorMass] = useState(0);
  const [errorStartdate, SetErrorStart] = useState("form-control ");
  const [errorEnddate, SetErrorEnd] = useState("form-control ");
  const [errorStartMass, SetErrorStartMass] = useState(0);
  const [errorEndMass, SetErrorEndMass] = useState(0);
  const [errorMassSta, ErrorMassSta] = useState(0);
  const [dateNow, setDateNow] = useState(1);
  const [printLebel, SetPrintLebel] = useState([]);
  const [sender_phone,Sender_phone] = useState("");
  const [national_id,National_id] = useState("");


  const [show, setShow] = useState(false);
  const handleClose = () => {
    SetListDimensions([]);
    setShow(false);
  }
  const handleShow = () => {
    setShow(true);
    setTimeout(() => {
      if (inputsRef.current[0]) {
        inputsRef.current[0].focus();
        inputsRef.current[0].select();
      }
    }, 10);
    setActiveTab(0);
  }
  

  useEffect(() => {
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: pageNo,
      perPage: perPage,
    });
    fetchListDriver();
  }, []);

  useEffect(() => {
    if (show && inputsRef.current[0]) {
      setTimeout(() => {
        inputsRef.current[0]?.focus();
        inputsRef.current[0]?.select();
      }, 100);
    }
  }, [show]);


    async function fetchListDriver() {
      let criteria = {
        keyword: "",
        roleType: "5",
        pageNo: 1,
        perPage: 2000,
      };
  
      Loading(1);
      const res = await ShowEmpService(criteria);
      // alert(res.numRowsAll>0)
      if (res.numRowsAll > 0) {
        // alert("tafa");
        setListDriver(res.result);
        // console.log(res.result);
        // setErrorMassNoData2(0);
        // alert(JSON.stringify(res.result))
        Loading(0);
      } else {
        // setErrorMassNoData2(1);
        Loading(0);
      }
    }
    

  async function fetchData(params) {
    Loading(1);
    let res = await GetData(params);
    if (res.numRowsAll > 0) {
      // const dataMerged = 
      // alert(res.result.map(item1 => ({ ...item1, ...res.sizes.find(item2 => item2.awb_code === item1.awb_code) })))
      // setData(res.result.map(item1 => ({ ...item1, ...res.sizes.find(item2 => item2.awb_code === item1.AWB_CODE) })));
      setData(res.result);
      setPage({
        current_page: res.pageNo,
        last_page: res.maxPage,
        total: res.numRowsAll,
      });
      setErrorMassNoData(0);
      Loading(0);
    } else {
      setCurrentPage(1);
      setPage({
        current_page: 1,
        last_page: 1,
        total: 0,
      });
      setErrorMassNoData(1);
      Loading(0);
    }
  }

  const handleChangeShipmentStatus = (e) => {
    setData([]);
    setErrorMassNoData([])
    setShipmentStatus(e);
    fetchData({
      shipmentStatus: e,
      empCode: user.username,
      pageNo: pageNo,
      perPage: perPage,
    });
  };

  const handleChangePageSize = (e) => {
    setData([]);
    setErrorMassNoData([])
    setPageSize(e);
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: pageNo,
      perPage: e,
    });
  };

  const handleChangePage = (e, newPage) => {
    setData([]);
    setErrorMassNoData([])
    setCurrentPage(newPage);
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: newPage,
      perPage: perPage,
    });
  };
  const { t } = useTranslation();

  async function CustomerType(data) {
    const result = await CustomerTypeService(data);
    if (data != null) {
      Cust(result.data);
    }
  }

  async function insertData(params) {
    console.log("params", params)
      try {
        let result = await InsertData2(params);
        if (result.status === 0) {
          swalError();
        } else {
          setData([]);
          setErrorMassNoData([])
          fetchData({
            shipmentStatus: shipmentStatus,
            empCode: user.username,
            pageNo: pageNo,
            perPage: perPage,
          });
      }
    }
    catch (e) {
      swalError({
        text: t(e.response.data.message),
      });
    }
  }

  function clear() {
    setDateNow(1);
    ErrorMassSta(0);
    SetErrorStartMass(0);
    SetErrorEndMass(0);
    SetErrorEnd("form-control");
    SetErrorStart("form-control");
    setErrorMassNoData(0);
    SetStart1("");
    SetStart2("");
    SetStart3("");
    SetEnd1("");
    SetEnd2("");
    SetEnd3("");
    SetError("form-control");
    SetErrorMass(0);
    setData([]);
    data([]);
    Cust_code([]);
    Cust([]);
    SetPrintLebel([]);
    Customer_type("");
    COD("");
    setKeyword("");
    SetStatus("");
    setCurrentPage(1);
    setPageSize(10);
    setPage({
      current_page: 1,
      last_page: 1,
      total: 0,
    });
  }

  return (
    <>
      <Formik
        validationSchema={schema}
        initialValues={{
          awbCode: "",
          shipmentStatus: shipmentStatus,
          empCode: user.username,
          items: listDimensions,
          driver: driver
        }}
        onSubmit={async (value, { setFieldValue }) => {
          value.empCode = user.username;
          value.driver= driver;
          insertData(value);
          value.awbCode = "";
          document.getElementById("awbCode").value = "";
          handleClose();
          // Loading(0);
        }}
      >
        {({ handleSubmit,errors, touched, handleBlur, setFieldValue, values }) => (
          <Form>
            <div className="card mb-5">
              <div className="card-body">
                <div className="container-fluid mt-2 mb-2">
                  <div className="text-center text-title-color">
                    <h2>{t('mis.accounting.title')}</h2>
                  </div>
                  <br />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      setData([]);
                      handleSubmit();
                    }}
                  >
                    <div className="row justify-content-md-center">
                      <div className="col-sm-4 col-md-4 px-md-1 mt-1">
                        <div className="input-group flex-nowrap">
                          <select
                            value={customer_type}
                            onChange={(e) => {
                              Customer_type(e.target.value);
                              CustomerType({ customer_type: e.target.value });
                            }}
                            className={"dropdown-custom2" + " " + setError}
                          >
                            {" "}
                            <option value={""}>{"ประเภทลูกค้า"}</option>
                            <option value={"4"}>{"เครดิต"}</option>
                            <option value={"3"}>{"หน้าร้าน"}</option>
                          </select>
                        </div>
                        {setErrorMass == 1 ? (
                          <font color="red" size="2">
                            {" "}
                            กรุณากรอกข้อมูล{" "}
                          </font>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-4 col-md-4 px-md-1 mt-1">
                        <div className="input-group flex-nowrap">
                          <Typeahead
                            id="basic-typeahead-single"
                            labelKey={(option) => `${option.cust_code} ${option.name}`}
                            onChange={(e, v) => {
                              Cust_code(e);
                            }}
                            options={cust}
                            getOptionLabel={(item) => item.cust_code}
                            placeholder="ชื่อ"
                            selected={cust_code}
                            value={cust_code}
                          />
                        </div>
                        {setErrorMass == 1 ? (
                          <font color="red" size="2">
                            {" "}
                            กรุณากรอกข้อมูล{" "}
                          </font>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-4 col-md-3 px-md-1 mt-1">
                        <div className="input-group flex-nowrap">
                          <input
                            type="text"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                            id="clear"
                            placeholder="ค้นหาบาร์โค้ด,หาจากเลขบัตรประชาชน,หาจากเบอร์โทรศัพท์"
                            className={setError}
                          />
                        </div>
                        {setErrorMass == 1 ? (
                          <font color="red" size="2">
                            {" "}
                            กรุณากรอกข้อมูล{" "}
                          </font>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <br />
                    <div className="row justify-content-md-center">
                      <div className="col-12 col-lg-2">
                        <br />
                        <center style={{ marginTop: "10px" }}>
                          <div className="form-check">
                            <input
                              checked={dateNow === 1 ? false : true}
                              style={{ width: "15px", height: "15px" }}
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                              onChange={(e) => {
                                if (dateNow === 1) {
                                  setDateNow(0);
                                  SetStart1(year);
                                  SetStart2(("0" + month).slice(-2));
                                  SetStart3(date);
                                  SetEnd1(year);
                                  SetEnd2(("0" + month).slice(-2));
                                  SetEnd3(date);
                                } else {
                                  setDateNow(1);
                                  SetStart1("");
                                  SetStart2("");
                                  SetStart3("");
                                  SetEnd1("");
                                  SetEnd2("");
                                  SetEnd3("");
                                }
                              }}
                            />
                            <label className="form-check-label" htmlFor="flexCheckDefault" style={{ marginLeft: "10px" }}>
                              วันที่ปัจจุบัน
                            </label>
                          </div>
                        </center>
                      </div>
                      <div className="col-12 col-lg-4">
                        <span>ตั้งแต่วันที่เปิดบิล</span>
                        <div className="row">
                          <div className="col-12 col-sm-4 col-md-4 px-md-1 mt-1">
                            <select
                              className={errorStartdate}
                              value={startdate1}
                              onChange={(e) => {
                                SetStart1(e.target.value);
                              }}
                            >
                              <option value=""> -- ปี -- </option>
                              {years.map((year, index) => (
                                <option key={`year${index}`} value={year}>
                                  {year + 543}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-sm-4 col-md-4  px-md-1 mt-1">
                            <select
                              className={errorStartdate}
                              value={startdate2}
                              onChange={(e) => {
                                SetStart2(e.target.value);
                              }}
                            >
                              <option value=""> -- เดือน -- </option>
                              {monthTH.map((item, index) => (
                                <option value={item.id} key={item.id}>
                                  {item.monthName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-sm-4 col-md-4  px-md-1 mt-1">
                            <select
                              className={errorStartdate}
                              value={startdate3}
                              onChange={(e) => {
                                SetStart3(e.target.value);
                              }}
                            >
                              <option value=""> -- วัน -- </option>
                              {Array.from(Array(31), (e, i) => (
                                <option value={i + 1}>{i + 1}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {errorStartMass == 1 && errorMassSta != 1 && errorMassSta != 2 && errorMassSta != 3 ? (
                          <font color="red" size="2">
                            {" "}
                            กรุณาเลือก ปี, เดือน, วัน{" "}
                          </font>
                        ) : (
                          ""
                        )}
                      </div>
      
                      <div className="col-12 col-lg-4">
                        <span>ถึงวันที่เปิดบิล</span>
                        <div className="row">
                          <div className="col-12 col-sm-4 px-md-1 mt-1">
                            <select
                              className={errorEnddate}
                              value={enddate1}
                              onChange={(e) => {
                                SetEnd1(e.target.value);
                              }}
                            >
                              <option value=""> -- ปี -- </option>
                              {years.map((year, index) => (
                                <option key={`year${index}`} value={year}>
                                  {year + 543}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-sm-4  px-md-1 mt-1">
                            <select
                              className={errorEnddate}
                              value={enddate2}
                              onChange={(e) => {
                                SetEnd2(e.target.value);
                              }}
                            >
                              <option value=""> -- เดือน -- </option>
                              {monthTH.map((item, index) => (
                                <option value={item.id} key={item.id}>
                                  {item.monthName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-sm-4  px-md-1 mt-1">
                            <select
                              className={errorEnddate}
                              value={enddate3}
                              onChange={(e) => {
                                SetEnd3(e.target.value);
                              }}
                            >
                              <option value=""> -- วัน -- </option>
                              {Array.from(Array(31), (e, i) => (
                                <option value={i + 1} key={i}>
                                  {i + 1}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {errorEndMass == 1 && errorMassSta != 1 && errorMassSta != 2 && errorMassSta != 3 ? (
                          <font color="red" size="2">
                            {" "}
                            กรุณาเลือก ปี, เดือน, วัน{" "}
                          </font>
                        ) : (
                          ""
                        )}
                      </div>
      
                      <div className="col-12 col-lg px-md-1 mt-0" style={{ display: "none" }}>
                        <br />
                        <center style={{ marginTop: "10px;" }}>
                          <div className="form-check form-check-inline">
                            <input
                              checked={true}
                              style={{ width: "15px", height: "15px" }}
                              className="form-check-input"
                              type="checkbox"
                              name="inlineRadioOptions"
                              id="inlineRadio1"
                              value="1"
                              // onChange={(e) => {
                              //   if (cod !== "1" ? true : false) {
                              //     COD(e.target.value);
                              //   } else {
                              //     COD("");
                              //   }
                              // }}
                            />
                            <label className="form-check-label" htmlFor="inlineRadio1">
                              มี COD
                            </label>
                          </div>
                        </center>
                      </div>
                    </div>
                    <br />
                    <center>
                      <i className="bi bi-search"></i>
                      <button
                        disabled={loading == 1 ? true : false}
                        type="submit"
                        className={loading == 1 ? "btn btn-secondary" : "btn btn-primary"}
                      >
                        <Icon.Search /> ค้นหา
                      </button>
                      <span>&nbsp;</span>
                      <button type="button" className="btn btn-secondary" onClick={clear}>
                        <Icon.ArrowClockwise /> ล้างค่า
                      </button>
                    </center>
                  </form>

                  <hr className="mt-4 mb-4" />
                  <h4>{t('mis.accounting.scanningHistory')}</h4>
                  <FilterData
                    perPage={perPage}
                    handleChangePageSize={handleChangePageSize}
                  />
                  <ShowData
                    data={data}
                    page={page}
                    loading={loading}
                    errorMassNoData={errorMassNoData}
                    pageNo={pageNo}
                    handleChangePage={handleChangePage}
                    perPage={perPage}
                  />
                </div>
              </div>
            </div>



          </Form>
        )}
      </Formik>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.Authentication,
});

export default connect(mapStateToProps)(Accounting);
